import { render, staticRenderFns } from "./Company_profile_wrap.vue?vue&type=template&id=5a754caf"
import script from "./Company_profile_wrap.vue?vue&type=script&lang=js"
export * from "./Company_profile_wrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports